import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../Component/Header/Header";
import { Sidebar } from "../../Component/Sidebar/Sidebar";

export const Dashboard = () => {
 
  return (
    <>
      <Header />
      <div className="container-view">
        <Sidebar />
        <Outlet />
      </div>
    </>
  );
};
